export default {
  computed: {
    // Default so Vue doesn't warn when components use this mixin without defining libraryAsset.
    // Components like library/show.vue override this with their own implementation.
    libraryAsset() {
      return undefined;
    },
    asset() {
      return this.attachment || this.topic || this.libraryAsset;
    },
    contentSource() {
      if (this.asset?.contentSourceId) {
        return this.$store.getters['contentSources/get'][this.asset.contentSourceId];
      }
    },
    contentSourceAttachment() {
      if (this.contentSource?.previewAttachmentId) {
        return this.$store.getters['attachments/get'][this.contentSource.previewAttachmentId];
      }
    },
    displayAttachment() {
      if (this.asset?.displayAttachmentId) {
        return this.$store.getters['attachments/get'][this.asset.displayAttachmentId];
      }
    },
    totalViews() {
      if (this.asset) {
        const key = `${this.asset.assetType.toLowerCase()}-${this.asset.id}`;
        return this.$store.getters['assetViews/get'][key];
      }
    },
  },
  watch: {
    asset(newAsset){
    const supportedAssetsWithViews = ['Attachment'];
    const isSupported = supportedAssetsWithViews.includes(newAsset?.assetType);
    if (newAsset && isSupported) {
      this.$store.dispatch('assetViews/fetch', { assetType: newAsset.assetType.toLowerCase(), assetId: newAsset.id });
    }
  },
  },
  mounted() {
    const supportedAssetsWithViews = ['Attachment'];
    const isSupported = supportedAssetsWithViews.includes(this.asset?.assetType);
    if (this.asset && isSupported) {
      this.$store.dispatch('assetViews/fetch', { assetType: this.asset.assetType.toLowerCase(), assetId: this.asset.id });
    }
  },
};
